import AvatarConnected from './AvatarConnected'

export default AvatarConnected
